import * as types from './RawExamActionType';

//Raw Exam Data - start
export const fetchRawExamDataRequest = (data) => ({
    type: types.FETCH_RAW_EXAM_DATA_REQUEST,
    payload: data
});
export const fetchRawExamDataSuccess = (data) => ({
    type: types.FETCH_RAW_EXAM_DATA_SUCCESS,
    payload: data
});
export const fetchRawExamDataFailure = (error) => ({
    type: types.FETCH_RAW_EXAM_DATA_FAILURE,
    payload: error
});

export const refreshRawExamDataRequest = (fromDate, toDate, userId) => ({
    type: types.REFRESH_RAW_EXAM_DATA_REQUEST,
    payload: { fromDate, toDate, userId }
});
export const refreshRawExamDataSuccess = (data) => ({
    type: types.REFRESH_RAW_EXAM_DATA_SUCCESS,
    payload: data
});
export const refreshRawExamDataFailure = (error) => ({
    type: types.REFRESH_RAW_EXAM_DATA_FAILURE,
    payload: error
});

export const exportRawExamDataToCSVRequest = (payload) => ({
    type: types.EXPORT_RAW_EXAM_DATA_REQUEST,
    payload
});
export const exportRawExamDataToCSVSuccess = () => ({
    type: types.EXPORT_RAW_EXAM_DATA_SUCCESS
});
export const exportRawExamDataToCSVFailure = (error) => ({
    type: types.EXPORT_RAW_EXAM_DATA_FAILURE,
    payload: error
});

export const clearRawExamData = () => ({
    type: types.CLEAR_RAW_EXAM_DATA
});
//Raw Exam Data - end
